import { useMemo } from "react";

import { AddonsCartBanner } from "app/components/AddonsCart/AddonsCartBanner/AddonsCartBanner";
import { DunningsBanners } from "app/components/Dunnings/DunningsBanners/DunningsBanners";
import { PageTopBannerRevealProvider } from "app/components/PageTopBanner/bannerRevealContext";
import { DiscountPageTopBanner } from "app/components/PageTopBanner/DiscountPageTopBanner/DiscountPageTopBanner";
import { PageTopBannerHost } from "app/components/PageTopBanner/PageTopBanner.styled";
import { PageTopBannerDict } from "app/components/PageTopBanner/PageTopBannerType";
import { usePageTopBanner } from "app/components/PageTopBanner/usePageTopBanner";
import TrialBanner from "app/components/React/TrialBanner/TrialBanner";
import { SeasonalCampaignBanner } from "app/marketing/components/seasonal-campaign/seeasonal-campaign-banner/SeasonalCampaignBanner";
import { ProjectsCtaBanner } from "app/pages/activation/components/AddonBanners/ProjectsCtaBanner/ProjectsCtaBanner";

export const PageTopBanner = () => {
    const { pageTopBannerType, bannerWrapperStyle, topBannerHeight } = usePageTopBanner();

    const component = useMemo(() => {
        switch (pageTopBannerType) {
            case PageTopBannerDict.DISCOUNT_BANNER:
                return <DiscountPageTopBanner />;
            case PageTopBannerDict.TRIAL_BANNER:
                return <TrialBanner />;
            case PageTopBannerDict.DUNNINGS:
                return <DunningsBanners />;
            case PageTopBannerDict.SEASONAL_CAMPAIGN_BANNER:
                return <SeasonalCampaignBanner />;
            case PageTopBannerDict.PROJECTS_PAGE_CTA:
                return <ProjectsCtaBanner />;
            case PageTopBannerDict.ADDON_CART:
                return <AddonsCartBanner />;
            default:
                return null;
        }
    }, [pageTopBannerType]);

    if (component === null) {
        return null;
    }

    return (
        <PageTopBannerHost
            data-automation={`page-top-banner-${pageTopBannerType}`}
            style={bannerWrapperStyle}
        >
            <PageTopBannerRevealProvider targetHeight={topBannerHeight}>{component}</PageTopBannerRevealProvider>
        </PageTopBannerHost>
    );
};
